import {
  Text,
  Button,
  Box,
  Heading,
  IconButton,
  ButtonGroup,
} from "@chakra-ui/react";
import { footerhome } from "../../images/svg";
import {
  BsFacebook,
  BsInstagram,
  BsLinkedin,
  BsTwitter,
  BsYoutube,
} from "react-icons/bs";
import { useNavigate } from "react-router-dom";
const companyData = [
  { name: "About Us", link: "/about-us" },
  { name: "How it works", link: "" },
  { name: "Purchase a Trip", link: "" },
  { name: "Gallery", link: "" },
  { name: "About our Value Added Services", link: "" },
];

const supportData = [
  { name: "Contact Us", link: "/contact-us" },
  { name: "List a Property", link: "/listing-info" },
  { name: "Hire an Experience Curator", link: "/contact-us" },
  { name: "Take a Virtual Tour of a Property", link: "/contact-us" },
];
const termsData = ["Privacy policy", "Terms and Condtions"];

function Footer() {
  const navigate = useNavigate();
  return (
    <Box>
      <Box bg="#0B2A3B" color="white" mt="30px" fontSize="12px">
        <Box
          display={["grid", "grid", "flex", "flex", "flex"]}
          m="auto"
          w="90%"
          flexWrap="wrap"
        >
          <Box w={["100%", "100%", "32%", "32%", "32%", "32%"]} mt="30px">
            {footerhome}
            <Text mt="20px" pr="90px">
              Real Properties Nigeria Ltd is a boutique real estate and
              facilities management company founded in 2012. With our unique
              contemporary style and passion for connecting people with
              property, we aspire to provide the ultimate real esate experience
              for today’s modern consumer.
            </Text>
            <Heading size="sm" mt="50px">
              Connect with us
            </Heading>
            <ButtonGroup variant="ghost" mb="30px">
              <IconButton
                as="a"
                variant="transpare"
                href="#"
                aria-label="LinkedIn"
                icon={<BsTwitter fontSize="1.25rem" />}
              />
              <IconButton
                as="a"
                variant="transpare"
                href="#"
                aria-label="GitHub"
                icon={<BsFacebook fontSize="1.25rem" />}
              />
              <IconButton
                as="a"
                variant="transpare"
                href="#"
                aria-label="GitHub"
                icon={<BsInstagram fontSize="1.25rem" />}
              />
              <IconButton
                as="a"
                variant="transpare"
                href="#"
                aria-label="Twitter"
                icon={<BsLinkedin fontSize="1.25rem" />}
              />
              <IconButton
                as="a"
                variant="transpare"
                href="#"
                aria-label="Twitter"
                icon={<BsYoutube fontSize="1.25rem" />}
              />
            </ButtonGroup>
          </Box>

          <Box>
            <Heading size="md" mt="60px" mb="10px" ml="10px">
              Company
            </Heading>
            {companyData.map((data) => (
              <b key={data} style={{ fontWeight: "500" }}>
                <Button
                  key={data}
                  fontSize="12px"
                  variant="transpare"
                  pr="70px"
                  onClick={() => {
                    navigate(data?.link);
                  }}
                >
                  {data?.name}
                </Button>
                <br></br>
              </b>
            ))}
          </Box>
          <Box>
            <Heading size="md" mt="60px" mb="10px" ml="10px">
              Support
            </Heading>
            {supportData.map((data) => (
              <b key={data} style={{ fontWeight: "500" }}>
                <Button
                  key={data}
                  fontSize="12px"
                  variant="transpare"
                  pr="70px"
                  onClick={() => {
                    navigate(data?.link);
                  }}
                >
                  {data?.name}
                </Button>
                <br></br>
              </b>
            ))}
          </Box>

          <Box>
            <Heading size="md" mt="60px" mb="10px" ml="10px">
              Terms and Policies
            </Heading>
            {termsData.map((data) => (
              <b key={data} style={{ fontWeight: "500" }}>
                <Button
                  key={data}
                  fontSize="12px"
                  variant="transpare"
                  pr="70px"
                >
                  {data}
                </Button>
                <br></br>
              </b>
            ))}
          </Box>
        </Box>
        <hr
          style={{
            color: "white",
            margin: "auto",
            width: "90%",
            border: " 1.5px solid rgba(255, 255, 255, 0.26)",
          }}
        ></hr>
        <Text textAlign="center" mt="20px" pb="70px" fontSize="sm">
          ©2023 Real Property. All rights reserved
        </Text>
      </Box>
    </Box>
  );
}

export default Footer;
